import React, { useEffect, useRef, useState } from 'react'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import { AppBar, Avatar, Badge, Button, FormControl, IconButton, InputAdornment, ListItemIcon, ListItemText, Menu, MenuItem, Tab, Tabs, TextField, Toolbar, Typography, useMediaQuery, } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PersonIcon from '@mui/icons-material/Person';
import { useDispatch, useSelector } from 'react-redux'
import DrawerMobile from './DrawerMobile';
import { logoutUser } from '../../features/slices/authSlice';
import { changeToLight, changeToDark } from '../../features/slices/themeSlice';
import logoImage from '../Images/logo.png'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import FilterFramesIcon from '@mui/icons-material/FilterFrames';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import FavoriteIcon from '@mui/icons-material/Favorite';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import './navbar.css'
import { useGetAllItemsQuery } from '../../features/fullApi';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import HomeIcon from '@mui/icons-material/Home';
import { getTotals } from '../../features/slices/cartSlice';
import { getTotalsFavorite } from '../../features/slices/favoriteSlice';

const Navbar = ({changeTheme, mode}) => {

  let user = useSelector(state => state.auth.user)
  if(!user) {
    user = JSON.parse(localStorage.getItem('user')) || ""
  }
  const searchInput = useRef(null);
  const theme = useTheme()
  const isMatch = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch()

  const lsTheme = JSON.parse(localStorage.getItem('theme'))

  const cart = useSelector(state => state.cart)
  useEffect(() => {
    dispatch(getTotals())
  }, [cart, dispatch])

  

  const favorite = useSelector(state => state.favorite)
  useEffect(() => {
    dispatch(getTotalsFavorite())
  }, [favorite, dispatch])

  useEffect(() => {

  }, [cart])

  const style = {
    "& label.Mui-focused": {
      color: "#fff"
    },
    "& label.Mui-hover": {
      outline:'none !important',
      border: 'none !important'
    },
    '& .MuiInput-underline:hover:before':
    {
        border: 'none !important'
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "transparent"
      },
      "&:hover fieldset": {
        outline:'none',
        borderColor:'transparent'
      },
      "&:focused fieldset": {
        outline:'none',
        borderColor:'transparent'
      },
      "&:blur fieldset": {
        outline:'none',
        borderColor:'transparent'
      },
      "&:blured fieldset": {
        outline:'none',
        borderColor:'transparent'
      },
      "&:blurred fieldset": {
        outline:'none',
        borderColor:'transparent'
      },
    }
  }



  const handleLogout = () => {
    dispatch(logoutUser())
    window.location.href="/"
  }

  const handleChangeTheme = () => {
    if(lsTheme === "dark") {
      dispatch(changeToLight("light"))
    } else if(lsTheme === "light") {
      dispatch(changeToDark("dark"))
    }
  }

  function stringAvatar(name) {
    return {
      sx: {
        bgcolor: "#FCF6B1",
        color:"#93032E"
      },
      children: name.charAt(0).toUpperCase(),
    };
  }

  const [value, setValue] = useState()

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const open = Boolean(anchorEl);
  const open2 = Boolean(anchorEl2)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };


  const [search, setSearch] = useState("")
  const {data, error, isLoading} = useGetAllItemsQuery()

  const clearSearch = () => {
    const resetSearch = async () => {
     setSearch("")
    };

    resetSearch()
  }


  const navigate = useNavigate()

  return (
    <AppBar color="primary">
    {!isMatch && !isLoading && (
    <Toolbar style={{width:'1200px', margin:'0 auto', display:'flex', justifyContent:'space-between'}}>
        <>
        <div style={{display:'flex', marginRight:'50px'}}>
          <div style={{display: 'flex', justifyContent: "center", alignItems:"center"}}>
          <a href="/" style={{display: 'flex', justifyContent: "center", alignItems:"center", marginRight:'30px'}}>
            <img src={logoImage} alt="logo" style={{width: '40px', height: '40px'}}/>
          </a>
          </div>
          <div style={{display:'flex', justifyContent:'center', alignItems:'center', marginRight:'auto'}}>
          <Button
              id="productsBtn"
              onClick={handleClick2}
              color="secondary"
              variant="outlined"
              style={{color:'#fff', width:'150px'}}
            >
              Products
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl2}
              open={open2}
              onClose={handleClose2}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem onClick={() => {
                navigate('/smartphones/1')
                handleClose2()
              }}>Smartphones</MenuItem>

              <MenuItem onClick={() => {
                navigate('/phonecases/1')
                handleClose2()
              }}>Phonecases</MenuItem>

              <MenuItem onClick={() => {
                navigate('/headphones/1')
                handleClose2()
              }}>Headphones</MenuItem>

              <MenuItem onClick={() => {
                navigate('/chargers/1')
                handleClose2()
              }}>Chargers</MenuItem>
            </Menu>
          </div>
        </div> 

          <div>
                <FormControl size="small">
                        <TextField sx={style} size="small" placeholder="search" onChange={(e) => setSearch(e.target.value)} value={search} style={{backgroundColor: '#fff', width: '300px', borderRadius:'10px'}}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="start">
                                {
                                  search === "" ? (
                                    <SearchIcon className="navIcon"/>
                                  ) : (<ClearIcon className="navIcon" onClick={clearSearch}/>)
                                }
                              </InputAdornment>
                            ),
                          }}
                        />
                </FormControl>
                <div className={!user && "searchBar"} style={{position:'absolute', zIndex:'999', width:'300px', backgroundColor:"#fff"}}>
                  {data?.filter((item) => {
                      const searchTerm = search?.toLowerCase();
                      const fullName = item?.title?.toLowerCase();
                      return (
                        searchTerm &&
                        fullName.includes(searchTerm) &&
                        fullName !== searchTerm
                      );
                    })
                    .slice(0, 10)
                    .map((item) => (
                      <div
                        id="dropdown"
                        onClick={() => {
                          clearSearch()
                          if(item.power) {
                            navigate(`/charger/${item._id}`)
                          } else if(item.storageId) {
                          navigate(`/smartphone/${item._id}`)
                          } else if(item.wear) {
                              navigate(`/headphone/${item._id}`)
                          } else if(item.materialId) {
                            navigate(`phonecase/${item._id}`)
                          }
                        }}
                        style={{display:'flex', padding:'10px', justifyContent:'space-around', alignItems:'center', border:'1px solid #eee'}}
                        key={item?.title}
                      >
                        <img src={item.img} alt="item img" style={{width:'50px', height:'50px', marginRight:'10px'}}/>
                        <Typography variant="subtitle1" style={{color:"#000"}}>{item?.title}</Typography>
                      </div>
                    ))}
                </div>
          </div>

            <div>
                  {!user &&
                  (<>
                      <Button style={{width:'150px', marginRight:'30px'}}  variant="contained" color="secondary" onClick={() => navigate('/register')}>
                          <Link style={{textDecoration: 'none', color: '#000'}} to="/register">Register</Link>
                      </Button>
                      <Button style={{width:'150px'}} variant="contained" color="secondary" onClick={() => navigate('/login')}>
                          <Link style={{textDecoration: 'none', color: '#000'}} to="/login">Login</Link>
                      </Button>
                  </>)
                }
            </div>



            <>
            {user &&
            <div style={{display:'flex', justifyContent:'space-evenly', width:'500px'}}>
                {user.isAdmin && 
                  <>
                      <Link className="navLink" to={"/users"}>    
                      <PersonIcon sx={{mr: 1}}/> 
                      Users
                  </Link>
                  <Link className="navLink" to={`/orders`}>
                      <FilterFramesIcon sx={{mr: 1}}/> 
                      Orders
                  </Link>
                  </>
                }
                <Link className="navLink" to={`/cart/find/${user?._id}`}>
                  <Badge badgeContent={cart.cartTotalQuantity} color="secondary"   
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}>
                    <AddShoppingCartIcon sx={{mr: 1}}/>
                  </Badge>
                  Cart
                </Link>
                <Link className="navLink" to={`/favorite/find/${user?._id}`}>
                  <Badge badgeContent={favorite.favoriteTotalQuantity} color="secondary"   
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}>
                    <FavoriteIcon sx={{mr: 1}}/>
                  </Badge>
                  Favorite
                </Link>
            </div>
            }
              {user && (
                <>
                    <Avatar {...stringAvatar(user?.username)} onClick={handleClick} id="avatar" />
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >
                      
                      <MenuItem onClick={() => 
                        {
                            navigate(`/account/${user._id}/user`)
                            handleClose()
                        }}
                      >

                      <ListItemIcon>
                          <PersonIcon fontSize="medium" />
                        </ListItemIcon>
                      <ListItemText>Account</ListItemText>
                      </MenuItem>                      

                      <MenuItem onClick={() => 
                        {
                            navigate(`/account/${user._id}/orders`)
                            handleClose()
                        }}>          
                        <ListItemIcon>
                          <FilterFramesIcon fontSize="medium" />
                        </ListItemIcon>
                        <ListItemText>Orders</ListItemText>
                      </MenuItem>

                      <MenuItem onClick={() => 
                        {
                            navigate(`/account/${user._id}/addresses`)
                            handleClose()
                        }}>          
                        <ListItemIcon>
                          <HomeIcon fontSize="medium" />
                        </ListItemIcon>
                        <ListItemText>Addresses</ListItemText>
                      </MenuItem>

                      <MenuItem onClick={() => 
                        {
                            navigate(`/contact`)
                            handleClose()
                        }}
                      >

                      <ListItemIcon>
                          <ContactSupportIcon fontSize="medium" />
                        </ListItemIcon>
                      <ListItemText>Contact</ListItemText>

                      </MenuItem>

                      <MenuItem onClick={handleClose}>
                        <Button variant="outlined" onClick={handleLogout}>Logout</Button>
                      </MenuItem>
                    </Menu>
                </>
 
              )}
            </>
          </>
      </Toolbar>
      )}
      {isMatch &&           
      <div style={{display:'flex', flexDirection:'column'}}>          
          <div style={{display:'flex', alignItems:'center'}}>
            <a href="/" style={{display: 'flex', justifyContent: "center", alignItems:"center", padding: '10px'}}>
              <img src={logoImage} alt="logo" style={{width: '40px', height: '40px'}}/>
            </a>
          <DrawerMobile handleLogout={handleLogout}></DrawerMobile> 
          </div>
          <div style={{textAlign:'center', paddingBottom:'10px'}}>
                <FormControl size="small">
                        <TextField sx={style} variant="outlined" size="small" placeholder="search" onChange={
                          (e) => setSearch(e.target.value)} value={search} style={{backgroundColor: '#fff', width: '300px', borderRadius:'10px'}}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="start">
                                {
                                  search === "" ? (
                                    <SearchIcon className="navIcon"/>
                                  ) : (<ClearIcon className="navIcon" onClick={clearSearch}/>)
                                }
                              </InputAdornment>
                            ),
                          }}
                        />
                </FormControl>
                <div style={{position:'absolute', marginLeft:'auto', marginRight:'auto', left:'0', right:'0', zIndex:'999', width:'300px', backgroundColor:"#fff"}}>
                  {data?.filter((item) => {
                      const searchTerm = search?.toLowerCase();
                      const fullName = item?.title?.toLowerCase();
                      return (
                        searchTerm &&
                        fullName.includes(searchTerm) &&
                        fullName !== searchTerm
                      );
                    })
                    .slice(0, 10)
                    .map((item) => (
                      <div
                        id="dropdown"
                        onClick={() => {
                          clearSearch()
                          navigate(`/smartphone/${item._id}`)}
                        }
                        style={{display:'flex', padding:'10px', justifyContent:'space-around', alignItems:'center', border:'1px solid #eee'}}
                        key={item?.title}
                      >
                        <img src={item.img} alt="item img" style={{width:'50px', height:'50px', marginRight:'10px'}}/>
                        <Typography variant="subtitle1" style={{color:"#000"}}>{item?.title}</Typography>
                      </div>
                    ))}
                </div>
          </div>
      </div>}
    </AppBar>
  )
}

export default Navbar